module.exports = __webpack_public_path__ + "media/images/categories/color/hand-sm-32d4d43883e935fbcf0002ec52fa7d80.png";